import React, { useState } from 'react'
import NiceModal, { useModal } from '@ebay/nice-modal-react'
import { Input } from 'antd'

import Modal from 'app/mainframe/components/Modals/Modal'
import Button from 'app/mainframe/components/Button/Button'
import { useAddLog } from 'app/mainframe/queries/log'
import { useCreateContent } from 'app/mainframe/queries/content'

const AddBookModal = NiceModal.create(
  ({ initialTitle = '', onCreated }: { initialTitle?: string; onCreated?: any }) => {
    const modal = useModal()
    const { mutateAsync: createContent, isLoading: isCreating } =
      useCreateContent()
    const { mutateAsync: addLog, isLoading: isAddingLog } = useAddLog()
    const [title, setTitle] = useState(initialTitle)
    const [author, setAuthor] = useState('')
    const [description, setDescription] = useState('')

    const loading = isCreating || isAddingLog

    const onSubmit = async event => {
      event.preventDefault()
      if (!title.trim()) return

      try {
        const content = await createContent({
          title: title.trim(),
          author: author.trim(),
          description: description.trim()
        })

        modal.hide()
        NiceModal.hide('search-modal')

        if (onCreated) {
          onCreated(content)
          return
        }

        const log = await addLog({ id: content.id, title: content.title })
        NiceModal.show('log-editor-modal', { slug: log.slug })
      } catch {
        // toast is handled by the mutation
      }
    }

    return (
      <Modal
        centered
        visible={modal.visible}
        onCancel={modal.hide}
        width='max-w-md'
      >
        <form onSubmit={onSubmit}>
          <h2 className='mb-1 text-center text-xl text-gray-50'>Add a book</h2>
          <p className='mb-5 text-center text-sm text-gray-400'>
            Title is enough. Author and description help later.
          </p>
          <label className='mb-3 block'>
            <span className='mb-1.5 block text-xs uppercase tracking-widest text-gray-400'>
              Title
            </span>
            <Input
              autoFocus
              size='large'
              value={title}
              onChange={event => setTitle(event.target.value)}
              placeholder='The Science of Scaling'
            />
          </label>
          <label className='mb-3 block'>
            <span className='mb-1.5 block text-xs uppercase tracking-widest text-gray-400'>
              Author
            </span>
            <Input
              size='large'
              value={author}
              onChange={event => setAuthor(event.target.value)}
              placeholder='Optional'
            />
          </label>
          <label className='mb-5 block'>
            <span className='mb-1.5 block text-xs uppercase tracking-widest text-gray-400'>
              Description
            </span>
            <Input.TextArea
              rows={4}
              value={description}
              onChange={event => setDescription(event.target.value)}
              placeholder='Optional'
            />
          </label>
          <Button
            htmlType='submit'
            type='primary'
            className='w-full'
            loading={loading}
            disabled={!title.trim()}
          >
            Add book
          </Button>
        </form>
      </Modal>
    )
  }
)

export const showAddBookModal = (initialTitle = '', onCreated = null) =>
  NiceModal.show('add-book-modal', { initialTitle, onCreated })

export default AddBookModal
